function accordionTypeTwo($elm) {
    $($elm).find('.js-accordion-type-2').click(function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('is-active');
        $(this).toggleClass('active').next().slideToggle('fast');
    }); 
}

export default accordionTypeTwo;